<ms-dropdown
    class="grid-dropdown"
    [options]="options"
    [activeOption]="activeOption"
    [disabled]="!column.enabled"
    [titleTemplate]="titleTemplate"
    [contentClass]="contentClass"
    [offerBadgeTemplate]="offerBadgeTemplate"
    [viewport]="popperAppendTo"
    (optionChange)="selected($event)">
</ms-dropdown>

<ng-template #titleTemplate let-title>
    <span class="market-switcher-group-title" *ngIf="hasMarketSwitcherGroupTitle"> {{ sitecore.eventGrid.MarketSwitcher_GroupTitle }} </span>
    {{ title }}
</ng-template>
